module.exports = __webpack_public_path__ + "img/top_bg2.3dcf2106.png";